module.exports = __webpack_public_path__ + "img/enable-3.2bfea0ab.jpg";